import { render, staticRenderFns } from "./13_ap_claves_pedimento.vue?vue&type=template&id=f763a006&scoped=true&"
import script from "./13_ap_claves_pedimento.vue?vue&type=script&lang=js&"
export * from "./13_ap_claves_pedimento.vue?vue&type=script&lang=js&"
import style0 from "./13_ap_claves_pedimento.vue?vue&type=style&index=0&id=f763a006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f763a006",
  null
  
)

export default component.exports